import { ConditionType } from '../models/condition-type';
import { EventUpdateStrategy } from '../models/event-update-strategy.enum';
import { TranslateService } from '../../core/translate/translate.service';
import { ScheduleConditionType } from '../models/schedule-condition-type.enum';

export class CostModuleMapper {

	static mapSchedule(item: any): any {
		return {
			...item,
			scheduleCriteria: item.scheduleCriteria.map(CostModuleMapper.mapScheduleCriteria)
		};
	}

	static mapScheduleCriteria(criteria: any): any {
		return {
			...criteria,
			conditionType: ScheduleConditionType[criteria.conditionType],
			eventUpdateStrategy: EventUpdateStrategy[criteria.eventUpdateStrategy]
		};
	}

	static mapDataType(dataType: number): string {
		switch (dataType) {
			case 1:
				return 'String';
			case 2:
				return 'Number';
			case 3:
				return 'Float';
			case 4:
				return 'Boolean';
			case 5:
				return 'Dictionary';
			case 6:
				return 'DateTime';
			default:
				return 'Unknown';
		}
	}

	static mapMappingTarget(mappingTarget: number): string {
		switch (mappingTarget) {
			case 1:
				return 'unitTag';
			case 2:
				return 'unitCustomValue';
		}
	}

	static getStatusText(status: number, translateService: TranslateService): string {
		switch (status) {
			case 1:
				return translateService.data['Active'];
			case 2:
				return translateService.data['Finished'];
			case 3:
				return translateService.data['Incoming'];
			case 4:
				return translateService.data['Exceeded'];
			case 5:
				return translateService.data['InProgress'];
			case 6:
				return translateService.data['Invalid'];
			default:
				return '';
		}
	}
}
